import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  date: { input: any; output: any; }
  datetime: { input: any; output: any; }
  jsonb: { input: any; output: any; }
  localtime: { input: any; output: any; }
  long: { input: any; output: any; }
  numeric: { input: any; output: any; }
  timezone: { input: any; output: any; }
  uuid: { input: any; output: any; }
};

/** Input type for querying application stage candidate events. */
export type AppStgCandidateEventsAppStgInput = {
  orderBy?: InputMaybe<DateOrderByInput>;
};

/** Input type for querying application stage applications. */
export type ApplicationStageApplicationInput = {
  isCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<DateOrderByInput>;
};

/** Represents the theme mode options for branding. */
export enum BrandingThemeMode {
  Dark = 'DARK',
  Light = 'LIGHT'
}

/** Represents buffer time before and after an interview */
export type BufferTime = {
  __typename?: 'BufferTime';
  /** Buffer time after the interview */
  after?: Maybe<Duration>;
  /** Buffer time before the interview */
  before?: Maybe<Duration>;
};

/** Input for setting buffer time before and after interviews */
export type BufferTimeInput = {
  after?: InputMaybe<DurationInput>;
  before?: InputMaybe<DurationInput>;
};

/** Represents buffer time settings for an interviewer */
export type BufferTimeSettings = {
  __typename?: 'BufferTimeSettings';
  /** Buffer time for the interviewer */
  bufferTime?: Maybe<BufferTime>;
  /** Level at which the settings are applied (org or interviewer) */
  level: SettingsLevel;
  /** Organization-wide buffer time settings */
  orgBufferTime?: Maybe<BufferTime>;
};

/**
 * Represents reasons a candidate might provide when cancelling a self-scheduled interview.
 * This enum helps categorize and track reasons for interview cancellations.
 */
export enum CandidateCancellationReason {
  /** The candidate has accepted another job offer. */
  AcceptedAnotherOffer = 'ACCEPTED_ANOTHER_OFFER',
  /** The candidate is unable to make the scheduled time. */
  CantMakeTime = 'CANT_MAKE_TIME',
  /** No specific reason has been set or provided by the candidate. */
  NotSet = 'NOT_SET',
  /** The candidate is no longer interested in the position. */
  NoLongerInterested = 'NO_LONGER_INTERESTED',
  /** The candidate has a reason not covered by the other options. */
  Other = 'OTHER'
}

/** Represents a date range with start and end dates. */
export type DateBlock = {
  __typename?: 'DateBlock';
  /** The end date of the block in yyyy-MM-dd format. */
  end?: Maybe<Scalars['String']['output']>;
  /** The start date of the block in yyyy-MM-dd format. */
  start?: Maybe<Scalars['String']['output']>;
};

/** Input type for specifying a date range. */
export type DateBlockInput = {
  /** The end date of the block in yyyy-MM-dd format. */
  end?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the block in yyyy-MM-dd format. */
  start?: InputMaybe<Scalars['String']['input']>;
};

/** Input type for specifying date-based ordering criteria. */
export type DateOrderByInput = {
  createdAt?: InputMaybe<Sort>;
  endAt?: InputMaybe<Sort>;
  startAt?: InputMaybe<Sort>;
  updatedAt?: InputMaybe<Sort>;
};

/** Input type for specifying a date-time range. */
export type DateTimeRangeInput = {
  endAt: Scalars['datetime']['input'];
  startAt: Scalars['datetime']['input'];
};

/** Output type for representing a date-time range. */
export type DateTimeRangeOutput = {
  __typename?: 'DateTimeRangeOutput';
  /** @deprecated No longer supported */
  end: Scalars['datetime']['output'];
  endAt: Scalars['datetime']['output'];
  /** @deprecated No longer supported */
  start: Scalars['datetime']['output'];
  startAt: Scalars['datetime']['output'];
};

/**
 * Specifies the scope of self-scheduled interviews to be deleted.
 * This enum is used when deleting self-scheduled interviews to determine which ones should be removed.
 */
export enum DeleteType {
  /** Delete all self-scheduled interviews, both past and upcoming. */
  All = 'ALL',
  /** Delete only past self-scheduled interviews. */
  Past = 'PAST',
  /** Delete only upcoming self-scheduled interviews. */
  Upcoming = 'UPCOMING'
}

/** Represents a duration of time. */
export type Duration = {
  __typename?: 'Duration';
  nanos: Scalars['numeric']['output'];
  seconds: Scalars['numeric']['output'];
};

/** Input type for specifying a duration. */
export type DurationInput = {
  nanos?: InputMaybe<Scalars['numeric']['input']>;
  seconds: Scalars['numeric']['input'];
};

/** Represents the result of an operation that doesn't return any data. */
export type EmptyResult = {
  __typename?: 'EmptyResult';
  result?: Maybe<Result>;
};

/** Represents feedback writing time settings for an interviewer */
export type FeedbackWritingTime = {
  __typename?: 'FeedbackWritingTime';
  /** Duration allocated for writing feedback */
  duration?: Maybe<Duration>;
  /** Level at which the settings are applied (org or interviewer) */
  level: SettingsLevel;
  /** Organization-wide feedback writing time settings */
  orgDuration?: Maybe<Duration>;
};

/** Input for feedback writing time duration */
export type FeedbackWritingTimeInput = {
  duration: DurationInput;
};

/** Represents the status of an integration connection. */
export enum IntegrationConnectionStatus {
  Connected = 'CONNECTED',
  NotConnected = 'NOT_CONNECTED',
  Syncing = 'SYNCING'
}

/** Input for a single interview limit */
export type InterviewLimitInput = {
  type: InterviewLimitType;
  value: Scalars['numeric']['input'];
};

/** Represents interview limit settings */
export type InterviewLimitSettings = {
  __typename?: 'InterviewLimitSettings';
  /** Current limit for the interviewer */
  currentLimit: LoadLimit;
  /** Level at which the settings are applied (org or interviewer) */
  level: SettingsLevel;
  /** Organization-wide limit */
  orgLimit: LoadLimit;
  /** Minimum load limit set by the organization */
  orgMinimum: MinimumLoadLimit;
};

/** Enum representing types of interview limits */
export enum InterviewLimitType {
  /** Limit based on the number of interviews */
  NumberOfInterviews = 'NUMBER_OF_INTERVIEWS',
  /** Limit based on the number of minutes */
  NumberOfMinutes = 'NUMBER_OF_MINUTES'
}

/** Represents interview limits for an interviewer */
export type InterviewLimits = {
  __typename?: 'InterviewLimits';
  /** Daily interview limit settings */
  dailyInterviewLimit: InterviewLimitSettings;
  /** Weekly interview limit settings */
  weeklyInterviewLimit: InterviewLimitSettings;
};

/** Input for setting interview limits */
export type InterviewLimitsInput = {
  dailyInterviewLimit?: InputMaybe<InterviewLimitInput>;
  weeklyInterviewLimit?: InputMaybe<InterviewLimitInput>;
};

/** Represents the location details for an interview. */
export type InterviewLocation = {
  __typename?: 'InterviewLocation';
  /** The type of interview location. Can be null if the type is not yet understood by the backend. */
  type?: Maybe<InterviewLocationType>;
  /** The value associated with the interview location (e.g., a link or phone number). */
  value?: Maybe<Scalars['String']['output']>;
};

/** Represents different types of interview locations or platforms. */
export enum InterviewLocationType {
  CustomLink = 'CUSTOM_LINK',
  GoogleMeet = 'GOOGLE_MEET',
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  Phone = 'PHONE',
  Zoom = 'ZOOM'
}

/** Represents different types of interview meeting locations or methods. */
export enum InterviewMeetingLocationType {
  CandidatePhone = 'CANDIDATE_PHONE',
  CustomLink = 'CUSTOM_LINK',
  CustomPhone = 'CUSTOM_PHONE',
  CustomText = 'CUSTOM_TEXT',
  GoogleMeet = 'GOOGLE_MEET',
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  None = 'NONE',
  NotSpecified = 'NOT_SPECIFIED',
  Zoom = 'ZOOM'
}

/**
 * Represents an interviewer in the system
 * Most of these fields are marked as nullable since they can have NONE permissions set on the
 * corresponding InterviewerPortalFieldPermission. Fields that are non-nullable will have minimum
 * READ permission for that field and can't go below that permission.
 */
export type Interviewer = {
  __typename?: 'Interviewer';
  /** Biography of the interviewer */
  bio?: Maybe<Scalars['String']['output']>;
  /** Buffer time settings for the interviewer */
  bufferTimeSettings?: Maybe<BufferTimeSettings>;
  /** Email address of the interviewer */
  email: Scalars['String']['output'];
  /** Feedback writing time settings for the interviewer */
  feedbackWritingTime?: Maybe<FeedbackWritingTime>;
  /** First name of the interviewer */
  firstName: Scalars['String']['output'];
  /** Unique identifier for the interviewer */
  id: Scalars['uuid']['output'];
  /** Interview limits for the interviewer */
  interviewLimits?: Maybe<InterviewLimits>;
  /** Keywords associated with the interviewer */
  keywords: InterviewerKeywords;
  /** Last name of the interviewer */
  lastName: Scalars['String']['output'];
  /** LinkedIn profile URL of the interviewer */
  linkedinUrl?: Maybe<Scalars['String']['output']>;
  /** The interviewer's preferred language/locale. Null when unset. */
  locale?: Maybe<Locale>;
  /** Dates when the interviewer is paused from conducting interviews */
  pauseDates?: Maybe<Array<LocalDateBlock>>;
  /** Planned availability for the interviewer */
  plannedAvailability?: Maybe<Array<PlannedAvailability>>;
  /** Profile picture of the interviewer */
  profilePicture?: Maybe<ProfilePicture>;
  /** Pronouns of the interviewer */
  pronouns?: Maybe<Scalars['String']['output']>;
  /** Timezone settings for the interviewer */
  timezoneSettings: TimezoneSettings;
  /** Job title of the interviewer */
  title?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the interviewer accepted the terms of service */
  tosAcceptedAt?: Maybe<Scalars['datetime']['output']>;
  /** Work hours settings for the interviewer */
  workHours?: Maybe<WorkHoursSettings>;
};

/** Represents field permissions for interviewers in the organization */
export type InterviewerFieldPermissions = {
  __typename?: 'InterviewerFieldPermissions';
  /** Permission for the bio field */
  bio?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the buffer time field */
  bufferTime?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the email address field */
  emailAddress?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the feedback writing time field */
  feedbackWritingTime?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the first name field */
  firstName?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the interview availability field */
  interviewAvailability?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the interview load capacity field */
  interviewLoadCapacity?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the interviewer keywords field */
  interviewerKeywords?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the last name field */
  lastName?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the LinkedIn URL field */
  linkedinUrl?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the pause from interviews field */
  pauseFromInterviews?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the profile picture field */
  profilePicture?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the pronouns field */
  pronouns?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the temporary availability field */
  temporaryAvailability?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the timezone field */
  timezone?: Maybe<InterviewerPortalFieldPermission>;
  /** Permission for the title field */
  title?: Maybe<InterviewerPortalFieldPermission>;
};

/** Represents keywords associated with an interviewer */
export type InterviewerKeywords = {
  __typename?: 'InterviewerKeywords';
  /** Keywords indicating availability for this interviewer */
  available: StringArrayPref;
  /** Keywords to avoid for this interviewer */
  avoid: StringArrayPref;
  /** Keywords indicating out-of-office status for this interviewer */
  outOfOffice: StringArrayPref;
  /** Keywords indicating recruiting blocks for this interviewer */
  recruitingBlocks: StringArrayPref;
};

/** Represents planned availability for an interviewer */
export type InterviewerPlannedAvailability = {
  __typename?: 'InterviewerPlannedAvailability';
  /** Creation timestamp */
  createdAt: Scalars['datetime']['output'];
  /** Identifier of the employee */
  employeeId: Scalars['uuid']['output'];
  /** End time of the availability */
  endAt: Scalars['datetime']['output'];
  /** Unique identifier for the planned availability */
  id: Scalars['uuid']['output'];
  /** Start time of the availability */
  startAt: Scalars['datetime']['output'];
  /** Timezone of the availability */
  timezone: Scalars['timezone']['output'];
  /** Last update timestamp */
  updatedAt: Scalars['datetime']['output'];
  /** Work hours for the availability period */
  workHours: TimeBlockWeek;
};

/** Enum representing permission levels for interviewer portal fields */
export enum InterviewerPortalFieldPermission {
  /** No permission */
  None = 'NONE',
  /** Read-only permission */
  Read = 'READ',
  /** Read and write permission */
  Write = 'WRITE'
}

/** Input for keywords associated with an interviewer */
export type KeywordsInput = {
  available?: InputMaybe<Array<Scalars['String']['input']>>;
  avoid?: InputMaybe<Array<Scalars['String']['input']>>;
  outOfOffice?: InputMaybe<Array<Scalars['String']['input']>>;
  recruitingBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents a load limit for interviews */
export type LoadLimit = {
  __typename?: 'LoadLimit';
  /** Type of the interview limit */
  type: InterviewLimitType;
  /** Numeric value of the limit */
  value: Scalars['numeric']['output'];
};

/** Represents a date range with start and end dates using the custom 'date' scalar type. */
export type LocalDateBlock = {
  __typename?: 'LocalDateBlock';
  end: Scalars['date']['output'];
  start: Scalars['date']['output'];
};

/** Represents a time range with start and end times using the custom 'localtime' scalar type. */
export type LocalTimeBlock = {
  __typename?: 'LocalTimeBlock';
  end: Scalars['localtime']['output'];
  start: Scalars['localtime']['output'];
};

/** Input type for specifying a time range. */
export type LocalTimeBlockInput = {
  end: Scalars['localtime']['input'];
  start: Scalars['localtime']['input'];
};

/** Represents a supported locale identifier. */
export enum Locale {
  DaDk = 'DA_DK',
  EnUs = 'EN_US',
  Es_419 = 'ES_419',
  EsEs = 'ES_ES',
  FrCa = 'FR_CA',
  FrFr = 'FR_FR',
  JaJp = 'JA_JP',
  KoKr = 'KO_KR',
  PtBr = 'PT_BR',
  ZhCn = 'ZH_CN',
  ZhTw = 'ZH_TW'
}

/** Represents the minimum load limit for interviews */
export type MinimumLoadLimit = {
  __typename?: 'MinimumLoadLimit';
  /** Minimum number of interviews */
  interviews: Scalars['numeric']['output'];
  /** Minimum number of minutes */
  minutes: Scalars['numeric']['output'];
};

/** Mutations related to interviewer operations */
export type Mutation = {
  __typename?: 'Mutation';
  /** Accept the terms of service for an interviewer */
  acceptTermsOfService?: Maybe<EmptyResult>;
  /** Create a new planned availability for an interviewer */
  plannedAvailabilityCreate: Interviewer;
  /** Delete a planned availability for an interviewer */
  plannedAvailabilityDelete?: Maybe<EmptyResult>;
  /** Update an existing planned availability for an interviewer */
  plannedAvailabilityUpdate: Interviewer;
  /** Update an interviewer's profile information */
  updateInterviewer: Interviewer;
};


/** Mutations related to interviewer operations */
export type MutationPlannedAvailabilityCreateArgs = {
  input: PlannedAvailabilityCreateInput;
};


/** Mutations related to interviewer operations */
export type MutationPlannedAvailabilityDeleteArgs = {
  input: PlannedAvailabilityDeleteInput;
};


/** Mutations related to interviewer operations */
export type MutationPlannedAvailabilityUpdateArgs = {
  input: PlannedAvailabilityUpdateInput;
};


/** Mutations related to interviewer operations */
export type MutationUpdateInterviewerArgs = {
  input: UpdateInterviewerInput;
};

/** Represents an organization in the system */
export type Org = {
  __typename?: 'Org';
  /** Status of the ATS (Applicant Tracking System) integration */
  atsStatus: IntegrationConnectionStatus;
  /** The organization's default locale. */
  defaultLocale: Locale;
  /** Status of the directory integration */
  directoryStatus: IntegrationConnectionStatus;
  /** Field permissions for interviewers in the organization */
  fieldPermissions: InterviewerFieldPermissions;
  /** Unique identifier for the organization */
  id: Scalars['uuid']['output'];
  /** Whether product AI is enabled (AI_ENABLED feature flag and org AI on/off pref). */
  isAiEnabled: Scalars['Boolean']['output'];
  /** Name of the organization */
  name: Scalars['String']['output'];
  /** Session inactivity timeout for the organization. Null when unset. */
  sessionInactivityTimeout?: Maybe<Duration>;
  /** Locales the organization has enabled for internal localization. Always non-empty. */
  supportedLocales: Array<Locale>;
};

/** Enum representing various user permissions */
export enum Permission {
  /**
   *  keep-sorted:begin
   *  Permission to perform administrative actions
   */
  CanAdmin = 'CAN_ADMIN',
  CanCreateFirstPartyAccessToken = 'CAN_CREATE_FIRST_PARTY_ACCESS_TOKEN',
  /**  Permission to create OAuth app connections */
  CanCreateOauthAppConnection = 'CAN_CREATE_OAUTH_APP_CONNECTION',
  /**  Permission to create third-party access tokens */
  CanCreateThirdPartyAccessToken = 'CAN_CREATE_THIRD_PARTY_ACCESS_TOKEN',
  CanDelegateToSchedulingAgent = 'CAN_DELEGATE_TO_SCHEDULING_AGENT',
  /**  Permission to conduct interviews */
  CanInterview = 'CAN_INTERVIEW',
  /**  Permission to manage additional permissions for Employees */
  CanManageAdditionalUserPermissions = 'CAN_MANAGE_ADDITIONAL_USER_PERMISSIONS',
  CanManageOrgSettings = 'CAN_MANAGE_ORG_SETTINGS',
  CanSchedule = 'CAN_SCHEDULE',
  /**  Permission to read the MCP, API, and privacy audit logs */
  ReadAuditLogs = 'READ_AUDIT_LOGS'
}

/** Represents a planned availability period for an interviewer */
export type PlannedAvailability = {
  __typename?: 'PlannedAvailability';
  endAt: Scalars['datetime']['output'];
  id: Scalars['uuid']['output'];
  startAt: Scalars['datetime']['output'];
  timezone: Scalars['timezone']['output'];
  workHours: TimeBlockWeek;
};

/** Input for creating a planned availability */
export type PlannedAvailabilityCreateInput = {
  endAt: Scalars['datetime']['input'];
  interviewerId: Scalars['uuid']['input'];
  startAt: Scalars['datetime']['input'];
  timezone: Scalars['timezone']['input'];
  workHours: TimeBlockWeekInput;
};

/** Input for deleting a planned availability */
export type PlannedAvailabilityDeleteInput = {
  id: Scalars['uuid']['input'];
};

/** Input for updating a planned availability */
export type PlannedAvailabilityUpdateInput = {
  endAt: Scalars['datetime']['input'];
  id: Scalars['uuid']['input'];
  startAt: Scalars['datetime']['input'];
  timezone: Scalars['timezone']['input'];
  workHours: TimeBlockWeekInput;
};

/**
 * Defines the visibility options for job option tabs in the candidate portal.
 * This enum is used to control when and how job option tabs are displayed to candidates.
 */
export enum PortalJobOptionsTabVisibilityType {
  /**
   * The job options tab is always visible to candidates, regardless of their current stage in the application process.
   * This option provides maximum transparency and allows candidates to see all available options at any time.
   */
  Always = 'ALWAYS',
  /**
   * The visibility of the job options tab depends on the candidate's current stage in the application process.
   * This allows for a dynamic user experience, showing relevant options as the candidate progresses through different stages of the application.
   */
  JobStage = 'JOB_STAGE',
  /**
   * The job options tab is never visible to candidates.
   * This option might be used for jobs where additional options are not applicable or when the recruitment process is strictly linear.
   */
  Never = 'NEVER'
}

/** Represents a profile picture with various size options. */
export type ProfilePicture = {
  __typename?: 'ProfilePicture';
  image32px?: Maybe<Scalars['String']['output']>;
  image64px?: Maybe<Scalars['String']['output']>;
  image128px?: Maybe<Scalars['String']['output']>;
  image256px?: Maybe<Scalars['String']['output']>;
  image512px?: Maybe<Scalars['String']['output']>;
  image1024px?: Maybe<Scalars['String']['output']>;
  imageOriginal?: Maybe<Scalars['String']['output']>;
};

/** Root Query type for the interviewer schema */
export type Query = {
  __typename?: 'Query';
  /** Retrieves the user information for the current actor */
  actorUserInfo: UserInfo;
  /** A simple hello query for testing purposes */
  hello?: Maybe<Scalars['String']['output']>;
  /** Retrieves information about the current interviewer */
  thisInterviewer?: Maybe<Interviewer>;
  /** Retrieves information about the current organization */
  thisOrg?: Maybe<Org>;
};

/** Indicates the status of a response to an invitation or request. */
export enum ResponseStatus {
  /** The recipient has accepted the invitation or request. */
  Accepted = 'ACCEPTED',
  /** The recipient has declined the invitation or request. */
  Declined = 'DECLINED',
  /** The recipient failed to respond within the required timeframe. */
  Missed = 'MISSED',
  /** The recipient has not yet responded and action is required. */
  NeedsAction = 'NEEDS_ACTION',
  /** The recipient responded Maybe, pending confirmation. */
  Tentative = 'TENTATIVE'
}

/** Indicates the outcome of an operation. */
export enum Result {
  /** The operation failed. */
  Failure = 'FAILURE',
  /** The operation was successful. */
  Success = 'SUCCESS'
}

/**
 * Defines the possible locations or platforms for a self-scheduled interview.
 * This enum helps specify how the interview will be conducted.
 */
export enum SelfScheduleLocation {
  /** The interview will use a custom location or platform not listed. */
  Custom = 'CUSTOM',
  /** The interview will be conducted via Google Meet. */
  Google = 'GOOGLE',
  /** The interview will be conducted via Microsoft Teams. */
  MicrosoftTeams = 'MICROSOFT_TEAMS',
  /** No specific location is set for the interview. */
  None = 'NONE',
  /** The interview will be conducted over the phone. */
  Phone = 'PHONE',
  /** The interview will be conducted via Zoom. */
  Zoom = 'ZOOM'
}

/**
 * Specifies who will host the meeting for a self-scheduled interview.
 * This enum is used for various meeting platforms (except Zoom, which uses SelfScheduleZoomHost).
 */
export enum SelfScheduleMeetingHost {
  /** A custom host will be used for the meeting. */
  CustomMeetingHost = 'CUSTOM_MEETING_HOST',
  /** The interviewer will host the meeting. */
  Interviewer = 'INTERVIEWER',
  /** The scheduler will host the meeting. */
  Scheduler = 'SCHEDULER'
}

/**
 * Specifies who will host the Zoom meeting for a self-scheduled interview.
 * This enum is used when the interview location is set to Zoom.
 */
export enum SelfScheduleZoomHost {
  /** A custom Zoom host will be used for the meeting. */
  CustomZoomHost = 'CUSTOM_ZOOM_HOST',
  /** The interviewer will host the Zoom meeting. */
  Interviewer = 'INTERVIEWER',
  /** The Zoom host has not been specified. */
  NotSet = 'NOT_SET',
  /** The scheduler will host the Zoom meeting. */
  Scheduler = 'SCHEDULER'
}

/** Enum representing the level at which settings are applied */
export enum SettingsLevel {
  /** Interviewer-level setting */
  Interviewer = 'INTERVIEWER',
  /** Organization-level setting */
  Org = 'ORG'
}

/** Represents sorting order options for queries that support ordering. */
export enum Sort {
  /** Ascending order (A to Z, 0 to 9, or oldest to newest). */
  Asc = 'ASC',
  /** Descending order (Z to A, 9 to 0, or newest to oldest). */
  Desc = 'DESC'
}

/**
 * Specifies the actions available for sourcing link tasks in the recruitment process.
 * These actions define the next steps a candidate can take when interacting with a sourcing link.
 */
export enum SourcingLinkTaskAction {
  /**
   * Prompts candidates to provide their availability for potential interview or assessment times.
   * This option is useful when the recruiter needs to collect availability information before scheduling.
   */
  Availability = 'AVAILABILITY',
  /**
   * Allows candidates to schedule their own interview or assessment time slot.
   * This option promotes flexibility and can improve candidate experience by giving them control over scheduling.
   */
  SelfSchedule = 'SELF_SCHEDULE'
}

/** Represents a preference for an array of strings */
export type StringArrayPref = {
  __typename?: 'StringArrayPref';
  /** Current preference (returns employee pref if set, org pref if employee pref is null) */
  current: Array<Scalars['String']['output']>;
  /** Level at which the preference is set (org or interviewer) */
  level?: Maybe<SettingsLevel>;
  /** Organization-wide preference */
  org: Array<Scalars['String']['output']>;
};

/** Represents a week of time blocks */
export type TimeBlockWeek = {
  __typename?: 'TimeBlockWeek';
  /** Time blocks for Friday */
  friday: Array<LocalTimeBlock>;
  /** Time blocks for Monday */
  monday: Array<LocalTimeBlock>;
  /** Time blocks for Saturday */
  saturday: Array<LocalTimeBlock>;
  /** Time blocks for Sunday */
  sunday: Array<LocalTimeBlock>;
  /** Time blocks for Thursday */
  thursday: Array<LocalTimeBlock>;
  /** Time blocks for Tuesday */
  tuesday: Array<LocalTimeBlock>;
  /** Time blocks for Wednesday */
  wednesday: Array<LocalTimeBlock>;
};

/** Input for work hours for a week */
export type TimeBlockWeekInput = {
  friday: Array<LocalTimeBlockInput>;
  monday: Array<LocalTimeBlockInput>;
  saturday: Array<LocalTimeBlockInput>;
  sunday: Array<LocalTimeBlockInput>;
  thursday: Array<LocalTimeBlockInput>;
  tuesday: Array<LocalTimeBlockInput>;
  wednesday: Array<LocalTimeBlockInput>;
};

/**
 * Represents a time range and the count of events within that range.
 * This type is useful for aggregating data about self-scheduled interviews over time periods.
 */
export type TimeRangeCount = {
  __typename?: 'TimeRangeCount';
  /** The number of events or interviews within the specified time range. */
  count: Scalars['numeric']['output'];
  /** The time range for which the count is calculated. */
  range: DateTimeRangeOutput;
};

/** Represents timezone settings for an interviewer */
export type TimezoneSettings = {
  __typename?: 'TimezoneSettings';
  /** Timezone of the interviewer's calendar */
  calendarTimezone: Scalars['timezone']['output'];
  /** Timezone of the interviewer */
  interviewerTimezone: Scalars['timezone']['output'];
  /** Indicates whether to use the calendar timezone */
  useCalendarTimezone: Scalars['Boolean']['output'];
};

/** Input for timezone settings */
export type TimezoneSettingsInput = {
  interviewerTimezone?: InputMaybe<Scalars['timezone']['input']>;
  useCalendarTimezone?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating an interviewer's profile */
export type UpdateInterviewerInput = {
  bio?: InputMaybe<Scalars['String']['input']>;
  bufferTime?: InputMaybe<BufferTimeInput>;
  feedbackWritingTime?: InputMaybe<FeedbackWritingTimeInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['uuid']['input'];
  interviewLimits?: InputMaybe<InterviewLimitsInput>;
  keywords?: InputMaybe<KeywordsInput>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  linkedinUrl?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Locale>;
  pauseDates?: InputMaybe<Array<DateBlockInput>>;
  profilePictureUrl?: InputMaybe<Scalars['String']['input']>;
  pronouns?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<TimezoneSettingsInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  workHours?: InputMaybe<TimeBlockWeekInput>;
};

/** Represents user information including permissions */
export type UserInfo = {
  __typename?: 'UserInfo';
  /** List of permissions granted to the user */
  permissions: Array<Permission>;
};

/** Represents work hours settings for an interviewer */
export type WorkHoursSettings = {
  __typename?: 'WorkHoursSettings';
  /** Work hours for the interviewer */
  hours: TimeBlockWeek;
  /** Level at which the settings are applied (org or interviewer) */
  level: SettingsLevel;
  /** Organization-wide work hours */
  orgHours: TimeBlockWeek;
};

export type InterviewerSessionActivityTimeoutQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewerSessionActivityTimeoutQuery = { __typename?: 'Query', thisOrg?: { __typename?: 'Org', id: any, sessionInactivityTimeout?: { __typename?: 'Duration', seconds: any, nanos: any } | null } | null };

export type DevFetchInterviewerQueryVariables = Exact<{ [key: string]: never; }>;


export type DevFetchInterviewerQuery = { __typename?: 'Query', thisInterviewer?: { __typename?: 'Interviewer', id: any, plannedAvailability?: Array<{ __typename?: 'PlannedAvailability', id: any }> | null } | null };

export type DevDeleteTemporaryAvailabilityMutationVariables = Exact<{
  input: PlannedAvailabilityDeleteInput;
}>;


export type DevDeleteTemporaryAvailabilityMutation = { __typename?: 'Mutation', plannedAvailabilityDelete?: { __typename?: 'EmptyResult', result?: Result | null } | null };

export type DevUpdateInterviewerMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type DevUpdateInterviewerMutation = { __typename?: 'Mutation', updateInterviewer: { __typename?: 'Interviewer', id: any } };

export type InterviewerSupportedLocalesQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewerSupportedLocalesQuery = { __typename?: 'Query', thisOrg?: { __typename?: 'Org', id: any, supportedLocales: Array<Locale> } | null };

export type GetOrgRequiredOnboardingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgRequiredOnboardingStatusQuery = { __typename?: 'Query', thisOrg?: { __typename?: 'Org', id: any, atsStatus: IntegrationConnectionStatus, directoryStatus: IntegrationConnectionStatus } | null };

export type UserTermsOfServiceQueryVariables = Exact<{ [key: string]: never; }>;


export type UserTermsOfServiceQuery = { __typename?: 'Query', thisInterviewer?: { __typename?: 'Interviewer', id: any, tosAcceptedAt?: any | null } | null };

export type InterviewerLocaleQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewerLocaleQuery = { __typename?: 'Query', thisInterviewer?: { __typename?: 'Interviewer', id: any, locale?: Locale | null } | null };

export type UpdateInterviewerLocaleMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type UpdateInterviewerLocaleMutation = { __typename?: 'Mutation', updateInterviewer: { __typename?: 'Interviewer', id: any, locale?: Locale | null } };

export type OrgNameQueryVariables = Exact<{ [key: string]: never; }>;


export type OrgNameQuery = { __typename?: 'Query', thisOrg?: { __typename?: 'Org', id: any, name: string } | null };

export type FeedbackWritingTimeSection_InterviewerFragment = { __typename?: 'Interviewer', id: any, feedbackWritingTime?: { __typename?: 'FeedbackWritingTime', level: SettingsLevel, duration?: { __typename?: 'Duration', seconds: any } | null, orgDuration?: { __typename?: 'Duration', seconds: any } | null } | null };

export type GetAdditionalPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdditionalPreferencesQuery = { __typename?: 'Query', thisInterviewer?: (
    { __typename?: 'Interviewer', id: any }
    & FeedbackWritingTimeSection_InterviewerFragment
  ) | null };

export type UpdateInterviewerAdditionalPreferencesMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type UpdateInterviewerAdditionalPreferencesMutation = { __typename?: 'Mutation', updateInterviewer: (
    { __typename?: 'Interviewer', id: any }
    & FeedbackWritingTimeSection_InterviewerFragment
  ) };

export type BufferTimesSection_InterviewerFragment = { __typename?: 'Interviewer', id: any, bufferTimeSettings?: { __typename?: 'BufferTimeSettings', level: SettingsLevel, bufferTime?: { __typename?: 'BufferTime', before?: { __typename?: 'Duration', seconds: any } | null, after?: { __typename?: 'Duration', seconds: any } | null } | null, orgBufferTime?: { __typename?: 'BufferTime', before?: { __typename?: 'Duration', seconds: any } | null, after?: { __typename?: 'Duration', seconds: any } | null } | null } | null };

export type TimeBlockWeekFragment = { __typename?: 'TimeBlockWeek', monday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, tuesday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, wednesday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, thursday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, friday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, saturday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, sunday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }> };

export type EditAvailabilityDialog_InterviewerFragment = { __typename?: 'Interviewer', workHours?: { __typename?: 'WorkHoursSettings', level: SettingsLevel, hours: (
      { __typename?: 'TimeBlockWeek' }
      & TimeBlockWeekFragment
    ), orgHours: (
      { __typename?: 'TimeBlockWeek' }
      & TimeBlockWeekFragment
    ) } | null };

export type EditLimitsButton_InterviewerFragment = { __typename?: 'Interviewer', interviewLimits?: { __typename?: 'InterviewLimits', dailyInterviewLimit: { __typename?: 'InterviewLimitSettings', level: SettingsLevel, currentLimit: { __typename?: 'LoadLimit', type: InterviewLimitType, value: any }, orgMinimum: { __typename?: 'MinimumLoadLimit', interviews: any, minutes: any }, orgLimit: { __typename?: 'LoadLimit', type: InterviewLimitType, value: any } }, weeklyInterviewLimit: { __typename?: 'InterviewLimitSettings', level: SettingsLevel, currentLimit: { __typename?: 'LoadLimit', type: InterviewLimitType, value: any }, orgMinimum: { __typename?: 'MinimumLoadLimit', interviews: any, minutes: any }, orgLimit: { __typename?: 'LoadLimit', type: InterviewLimitType, value: any } } } | null };

export type EditTimezoneDialog_InterviewerFragment = { __typename?: 'Interviewer', id: any, timezoneSettings: { __typename?: 'TimezoneSettings', interviewerTimezone: any, calendarTimezone: any, useCalendarTimezone: boolean } };

export type InterviewerWorkHoursFragment = { __typename?: 'Interviewer', interviewLimits?: { __typename?: 'InterviewLimits', dailyInterviewLimit: { __typename?: 'InterviewLimitSettings', orgMinimum: { __typename?: 'MinimumLoadLimit', interviews: any, minutes: any } }, weeklyInterviewLimit: { __typename?: 'InterviewLimitSettings', orgMinimum: { __typename?: 'MinimumLoadLimit', interviews: any, minutes: any } } } | null, workHours?: { __typename?: 'WorkHoursSettings', hours: { __typename?: 'TimeBlockWeek', monday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, tuesday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, wednesday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, thursday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, friday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, saturday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, sunday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }> } } | null };

export type GetAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailabilityQuery = { __typename?: 'Query', thisInterviewer?: (
    { __typename?: 'Interviewer', id: any, timezoneSettings: { __typename?: 'TimezoneSettings', interviewerTimezone: any, calendarTimezone: any, useCalendarTimezone: boolean }, interviewLimits?: { __typename?: 'InterviewLimits', dailyInterviewLimit: { __typename?: 'InterviewLimitSettings', level: SettingsLevel, currentLimit: { __typename?: 'LoadLimit', type: InterviewLimitType, value: any } }, weeklyInterviewLimit: { __typename?: 'InterviewLimitSettings', level: SettingsLevel, currentLimit: { __typename?: 'LoadLimit', type: InterviewLimitType, value: any } } } | null }
    & EditLimitsButton_InterviewerFragment
    & EditAvailabilityDialog_InterviewerFragment
    & BufferTimesSection_InterviewerFragment
    & InterviewerWorkHoursFragment
  ) | null };

export type UpdateInterviewerAvailabilityMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type UpdateInterviewerAvailabilityMutation = { __typename?: 'Mutation', updateInterviewer: (
    { __typename?: 'Interviewer', id: any, timezoneSettings: { __typename?: 'TimezoneSettings', interviewerTimezone: any, calendarTimezone: any, useCalendarTimezone: boolean }, interviewLimits?: { __typename?: 'InterviewLimits', dailyInterviewLimit: { __typename?: 'InterviewLimitSettings', level: SettingsLevel, currentLimit: { __typename?: 'LoadLimit', type: InterviewLimitType, value: any } }, weeklyInterviewLimit: { __typename?: 'InterviewLimitSettings', level: SettingsLevel, currentLimit: { __typename?: 'LoadLimit', type: InterviewLimitType, value: any } } } | null }
    & BufferTimesSection_InterviewerFragment
    & InterviewerWorkHoursFragment
  ) };

export type ExternalInfoFragment = { __typename?: 'Interviewer', id: any, firstName: string, lastName: string, title?: string | null, email: string, linkedinUrl?: string | null, pronouns?: string | null, bio?: string | null, profilePicture?: { __typename?: 'ProfilePicture', imageOriginal?: string | null, image256px?: string | null } | null };

export type GetExternalInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExternalInfoQuery = { __typename?: 'Query', thisInterviewer?: (
    { __typename?: 'Interviewer' }
    & ExternalInfoFragment
  ) | null };

export type UpdateInterviewerExternalInfoMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type UpdateInterviewerExternalInfoMutation = { __typename?: 'Mutation', updateInterviewer: (
    { __typename?: 'Interviewer' }
    & ExternalInfoFragment
  ) };

export type AvailableKeywordsField_InterviewerFragment = { __typename?: 'Interviewer', id: any, keywords: { __typename?: 'InterviewerKeywords', available: { __typename?: 'StringArrayPref', current: Array<string>, org: Array<string>, level?: SettingsLevel | null }, recruitingBlocks: { __typename?: 'StringArrayPref', current: Array<string> }, avoid: { __typename?: 'StringArrayPref', current: Array<string> }, outOfOffice: { __typename?: 'StringArrayPref', current: Array<string> } } };

export type UpdateInterviewerAvailabileKeywordsMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type UpdateInterviewerAvailabileKeywordsMutation = { __typename?: 'Mutation', updateInterviewer: { __typename?: 'Interviewer', id: any, keywords: { __typename?: 'InterviewerKeywords', available: { __typename?: 'StringArrayPref', current: Array<string>, org: Array<string>, level?: SettingsLevel | null } } } };

export type AvoidKeywordsField_InterviewerFragment = { __typename?: 'Interviewer', id: any, keywords: { __typename?: 'InterviewerKeywords', available: { __typename?: 'StringArrayPref', current: Array<string> }, recruitingBlocks: { __typename?: 'StringArrayPref', current: Array<string> }, avoid: { __typename?: 'StringArrayPref', current: Array<string>, org: Array<string>, level?: SettingsLevel | null }, outOfOffice: { __typename?: 'StringArrayPref', current: Array<string> } } };

export type UpdateInterviewerAvoidKeywordsMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type UpdateInterviewerAvoidKeywordsMutation = { __typename?: 'Mutation', updateInterviewer: { __typename?: 'Interviewer', id: any, keywords: { __typename?: 'InterviewerKeywords', avoid: { __typename?: 'StringArrayPref', current: Array<string>, org: Array<string>, level?: SettingsLevel | null } } } };

export type OutOfOfficeKeywordsField_InterviewerFragment = { __typename?: 'Interviewer', id: any, keywords: { __typename?: 'InterviewerKeywords', available: { __typename?: 'StringArrayPref', current: Array<string> }, recruitingBlocks: { __typename?: 'StringArrayPref', current: Array<string> }, avoid: { __typename?: 'StringArrayPref', current: Array<string> }, outOfOffice: { __typename?: 'StringArrayPref', current: Array<string>, org: Array<string>, level?: SettingsLevel | null } } };

export type UpdateInterviewerOutOfOfficeKeywordsMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type UpdateInterviewerOutOfOfficeKeywordsMutation = { __typename?: 'Mutation', updateInterviewer: { __typename?: 'Interviewer', id: any, keywords: { __typename?: 'InterviewerKeywords', outOfOffice: { __typename?: 'StringArrayPref', current: Array<string>, org: Array<string>, level?: SettingsLevel | null } } } };

export type RecruitingBlocksKeywordsField_InterviewerFragment = { __typename?: 'Interviewer', id: any, keywords: { __typename?: 'InterviewerKeywords', available: { __typename?: 'StringArrayPref', current: Array<string> }, recruitingBlocks: { __typename?: 'StringArrayPref', current: Array<string>, org: Array<string>, level?: SettingsLevel | null }, avoid: { __typename?: 'StringArrayPref', current: Array<string> }, outOfOffice: { __typename?: 'StringArrayPref', current: Array<string> } } };

export type UpdateInterviewerRecruitingBlocksKeywordsMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type UpdateInterviewerRecruitingBlocksKeywordsMutation = { __typename?: 'Mutation', updateInterviewer: { __typename?: 'Interviewer', id: any, keywords: { __typename?: 'InterviewerKeywords', recruitingBlocks: { __typename?: 'StringArrayPref', current: Array<string>, org: Array<string>, level?: SettingsLevel | null } } } };

export type InterviewerKeywordsQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewerKeywordsQuery = { __typename?: 'Query', thisInterviewer?: (
    { __typename?: 'Interviewer' }
    & AvailableKeywordsField_InterviewerFragment
    & AvoidKeywordsField_InterviewerFragment
    & OutOfOfficeKeywordsField_InterviewerFragment
    & RecruitingBlocksKeywordsField_InterviewerFragment
  ) | null };

export type WorkHoursFragment = { __typename?: 'TimeBlockWeek', monday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, tuesday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, wednesday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, thursday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, friday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, saturday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }>, sunday: Array<{ __typename?: 'LocalTimeBlock', start: any, end: any }> };

export type PlannedAvailabilityFragment = { __typename?: 'PlannedAvailability', id: any, startAt: any, endAt: any, timezone: any, workHours: (
    { __typename?: 'TimeBlockWeek' }
    & WorkHoursFragment
  ) };

export type GetPlannedAvailabilityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPlannedAvailabilityQuery = { __typename?: 'Query', thisInterviewer?: { __typename?: 'Interviewer', id: any, plannedAvailability?: Array<(
      { __typename?: 'PlannedAvailability' }
      & PlannedAvailabilityFragment
    )> | null, pauseDates?: Array<{ __typename?: 'LocalDateBlock', start: any, end: any }> | null, workHours?: { __typename?: 'WorkHoursSettings', orgHours: (
        { __typename?: 'TimeBlockWeek' }
        & WorkHoursFragment
      ) } | null } | null };

export type UpdateInterviewerPauseDatesMutationVariables = Exact<{
  input: UpdateInterviewerInput;
}>;


export type UpdateInterviewerPauseDatesMutation = { __typename?: 'Mutation', updateInterviewer: { __typename?: 'Interviewer', id: any, pauseDates?: Array<{ __typename?: 'LocalDateBlock', start: any, end: any }> | null } };

export type CreatePlannedAvailabilityMutationVariables = Exact<{
  input: PlannedAvailabilityCreateInput;
}>;


export type CreatePlannedAvailabilityMutation = { __typename?: 'Mutation', plannedAvailabilityCreate: { __typename?: 'Interviewer', id: any, plannedAvailability?: Array<(
      { __typename?: 'PlannedAvailability' }
      & PlannedAvailabilityFragment
    )> | null } };

export type UpdatePlannedAvailabilityMutationVariables = Exact<{
  input: PlannedAvailabilityUpdateInput;
}>;


export type UpdatePlannedAvailabilityMutation = { __typename?: 'Mutation', plannedAvailabilityUpdate: { __typename?: 'Interviewer', id: any, plannedAvailability?: Array<(
      { __typename?: 'PlannedAvailability' }
      & PlannedAvailabilityFragment
    )> | null } };

export type DeletePlannedAvailabilityMutationVariables = Exact<{
  input: PlannedAvailabilityDeleteInput;
}>;


export type DeletePlannedAvailabilityMutation = { __typename?: 'Mutation', plannedAvailabilityDelete?: { __typename?: 'EmptyResult', result?: Result | null } | null };

export type SaveTermsOfServiceMutationVariables = Exact<{ [key: string]: never; }>;


export type SaveTermsOfServiceMutation = { __typename?: 'Mutation', acceptTermsOfService?: { __typename?: 'EmptyResult', result?: Result | null } | null };

export type GetInterviewerConfigQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInterviewerConfigQuery = { __typename?: 'Query', thisOrg?: { __typename?: 'Org', id: any, fieldPermissions: { __typename?: 'InterviewerFieldPermissions', firstName?: InterviewerPortalFieldPermission | null, lastName?: InterviewerPortalFieldPermission | null, title?: InterviewerPortalFieldPermission | null, emailAddress?: InterviewerPortalFieldPermission | null, linkedinUrl?: InterviewerPortalFieldPermission | null, timezone?: InterviewerPortalFieldPermission | null, interviewLoadCapacity?: InterviewerPortalFieldPermission | null, interviewAvailability?: InterviewerPortalFieldPermission | null, temporaryAvailability?: InterviewerPortalFieldPermission | null, pauseFromInterviews?: InterviewerPortalFieldPermission | null, interviewerKeywords?: InterviewerPortalFieldPermission | null, profilePicture?: InterviewerPortalFieldPermission | null, bio?: InterviewerPortalFieldPermission | null, pronouns?: InterviewerPortalFieldPermission | null, bufferTime?: InterviewerPortalFieldPermission | null, feedbackWritingTime?: InterviewerPortalFieldPermission | null } } | null };

export const FeedbackWritingTimeSection_InterviewerFragmentDoc = gql`
    fragment FeedbackWritingTimeSection_interviewer on Interviewer {
  id
  feedbackWritingTime {
    level
    duration {
      seconds
    }
    orgDuration {
      seconds
    }
  }
}
    `;
export const BufferTimesSection_InterviewerFragmentDoc = gql`
    fragment BufferTimesSection_interviewer on Interviewer {
  id
  bufferTimeSettings {
    level
    bufferTime {
      before {
        seconds
      }
      after {
        seconds
      }
    }
    orgBufferTime {
      before {
        seconds
      }
      after {
        seconds
      }
    }
  }
}
    `;
export const TimeBlockWeekFragmentDoc = gql`
    fragment TimeBlockWeek on TimeBlockWeek {
  monday {
    start
    end
  }
  tuesday {
    start
    end
  }
  wednesday {
    start
    end
  }
  thursday {
    start
    end
  }
  friday {
    start
    end
  }
  saturday {
    start
    end
  }
  sunday {
    start
    end
  }
}
    `;
export const EditAvailabilityDialog_InterviewerFragmentDoc = gql`
    fragment EditAvailabilityDialog_interviewer on Interviewer {
  workHours {
    hours {
      ...TimeBlockWeek
    }
    orgHours {
      ...TimeBlockWeek
    }
    level
  }
}
    ${TimeBlockWeekFragmentDoc}`;
export const EditLimitsButton_InterviewerFragmentDoc = gql`
    fragment EditLimitsButton_interviewer on Interviewer {
  interviewLimits {
    dailyInterviewLimit {
      currentLimit {
        type
        value
      }
      orgMinimum {
        interviews
        minutes
      }
      orgLimit {
        type
        value
      }
      level
    }
    weeklyInterviewLimit {
      currentLimit {
        type
        value
      }
      orgMinimum {
        interviews
        minutes
      }
      orgLimit {
        type
        value
      }
      level
    }
  }
}
    `;
export const EditTimezoneDialog_InterviewerFragmentDoc = gql`
    fragment EditTimezoneDialog_interviewer on Interviewer {
  id
  timezoneSettings {
    interviewerTimezone
    calendarTimezone
    useCalendarTimezone
  }
}
    `;
export const InterviewerWorkHoursFragmentDoc = gql`
    fragment InterviewerWorkHours on Interviewer {
  interviewLimits {
    dailyInterviewLimit {
      orgMinimum {
        interviews
        minutes
      }
    }
    weeklyInterviewLimit {
      orgMinimum {
        interviews
        minutes
      }
    }
  }
  workHours {
    hours {
      monday {
        start
        end
      }
      tuesday {
        start
        end
      }
      wednesday {
        start
        end
      }
      thursday {
        start
        end
      }
      friday {
        start
        end
      }
      saturday {
        start
        end
      }
      sunday {
        start
        end
      }
    }
  }
}
    `;
export const ExternalInfoFragmentDoc = gql`
    fragment ExternalInfo on Interviewer {
  id
  firstName
  lastName
  title
  email
  linkedinUrl
  profilePicture {
    imageOriginal
    image256px
  }
  pronouns
  bio
}
    `;
export const AvailableKeywordsField_InterviewerFragmentDoc = gql`
    fragment AvailableKeywordsField_interviewer on Interviewer {
  id
  keywords {
    available {
      current
      org
      level
    }
    recruitingBlocks {
      current
    }
    avoid {
      current
    }
    outOfOffice {
      current
    }
  }
}
    `;
export const AvoidKeywordsField_InterviewerFragmentDoc = gql`
    fragment AvoidKeywordsField_interviewer on Interviewer {
  id
  keywords {
    available {
      current
    }
    recruitingBlocks {
      current
    }
    avoid {
      current
      org
      level
    }
    outOfOffice {
      current
    }
  }
}
    `;
export const OutOfOfficeKeywordsField_InterviewerFragmentDoc = gql`
    fragment OutOfOfficeKeywordsField_interviewer on Interviewer {
  id
  keywords {
    available {
      current
    }
    recruitingBlocks {
      current
    }
    avoid {
      current
    }
    outOfOffice {
      current
      org
      level
    }
  }
}
    `;
export const RecruitingBlocksKeywordsField_InterviewerFragmentDoc = gql`
    fragment RecruitingBlocksKeywordsField_interviewer on Interviewer {
  id
  keywords {
    available {
      current
    }
    recruitingBlocks {
      current
      org
      level
    }
    avoid {
      current
    }
    outOfOffice {
      current
    }
  }
}
    `;
export const WorkHoursFragmentDoc = gql`
    fragment WorkHours on TimeBlockWeek {
  monday {
    start
    end
  }
  tuesday {
    start
    end
  }
  wednesday {
    start
    end
  }
  thursday {
    start
    end
  }
  friday {
    start
    end
  }
  saturday {
    start
    end
  }
  sunday {
    start
    end
  }
}
    `;
export const PlannedAvailabilityFragmentDoc = gql`
    fragment PlannedAvailability on PlannedAvailability {
  id
  startAt
  endAt
  timezone
  workHours {
    ...WorkHours
  }
}
    ${WorkHoursFragmentDoc}`;
export const InterviewerSessionActivityTimeoutDocument = gql`
    query InterviewerSessionActivityTimeout {
  thisOrg {
    id
    sessionInactivityTimeout {
      seconds
      nanos
    }
  }
}
    `;

/**
 * __useInterviewerSessionActivityTimeoutQuery__
 *
 * To run a query within a React component, call `useInterviewerSessionActivityTimeoutQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerSessionActivityTimeoutQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerSessionActivityTimeoutQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterviewerSessionActivityTimeoutQuery(baseOptions?: Apollo.QueryHookOptions<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>(InterviewerSessionActivityTimeoutDocument, options);
      }
export function useInterviewerSessionActivityTimeoutLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>(InterviewerSessionActivityTimeoutDocument, options);
        }
// @ts-ignore
export function useInterviewerSessionActivityTimeoutSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>;
export function useInterviewerSessionActivityTimeoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerSessionActivityTimeoutQuery | undefined, InterviewerSessionActivityTimeoutQueryVariables>;
export function useInterviewerSessionActivityTimeoutSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>(InterviewerSessionActivityTimeoutDocument, options);
        }
export type InterviewerSessionActivityTimeoutQueryHookResult = ReturnType<typeof useInterviewerSessionActivityTimeoutQuery>;
export type InterviewerSessionActivityTimeoutLazyQueryHookResult = ReturnType<typeof useInterviewerSessionActivityTimeoutLazyQuery>;
export type InterviewerSessionActivityTimeoutSuspenseQueryHookResult = ReturnType<typeof useInterviewerSessionActivityTimeoutSuspenseQuery>;
export type InterviewerSessionActivityTimeoutQueryResult = Apollo.QueryResult<InterviewerSessionActivityTimeoutQuery, InterviewerSessionActivityTimeoutQueryVariables>;
export const DevFetchInterviewerDocument = gql`
    query DevFetchInterviewer {
  thisInterviewer {
    id
    plannedAvailability {
      id
    }
  }
}
    `;

/**
 * __useDevFetchInterviewerQuery__
 *
 * To run a query within a React component, call `useDevFetchInterviewerQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevFetchInterviewerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevFetchInterviewerQuery({
 *   variables: {
 *   },
 * });
 */
export function useDevFetchInterviewerQuery(baseOptions?: Apollo.QueryHookOptions<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>(DevFetchInterviewerDocument, options);
      }
export function useDevFetchInterviewerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>(DevFetchInterviewerDocument, options);
        }
// @ts-ignore
export function useDevFetchInterviewerSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>): Apollo.UseSuspenseQueryResult<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>;
export function useDevFetchInterviewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>): Apollo.UseSuspenseQueryResult<DevFetchInterviewerQuery | undefined, DevFetchInterviewerQueryVariables>;
export function useDevFetchInterviewerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>(DevFetchInterviewerDocument, options);
        }
export type DevFetchInterviewerQueryHookResult = ReturnType<typeof useDevFetchInterviewerQuery>;
export type DevFetchInterviewerLazyQueryHookResult = ReturnType<typeof useDevFetchInterviewerLazyQuery>;
export type DevFetchInterviewerSuspenseQueryHookResult = ReturnType<typeof useDevFetchInterviewerSuspenseQuery>;
export type DevFetchInterviewerQueryResult = Apollo.QueryResult<DevFetchInterviewerQuery, DevFetchInterviewerQueryVariables>;
export const DevDeleteTemporaryAvailabilityDocument = gql`
    mutation DevDeleteTemporaryAvailability($input: PlannedAvailabilityDeleteInput!) {
  plannedAvailabilityDelete(input: $input) {
    result
  }
}
    `;
export type DevDeleteTemporaryAvailabilityMutationFn = Apollo.MutationFunction<DevDeleteTemporaryAvailabilityMutation, DevDeleteTemporaryAvailabilityMutationVariables>;

/**
 * __useDevDeleteTemporaryAvailabilityMutation__
 *
 * To run a mutation, you first call `useDevDeleteTemporaryAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevDeleteTemporaryAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devDeleteTemporaryAvailabilityMutation, { data, loading, error }] = useDevDeleteTemporaryAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevDeleteTemporaryAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<DevDeleteTemporaryAvailabilityMutation, DevDeleteTemporaryAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevDeleteTemporaryAvailabilityMutation, DevDeleteTemporaryAvailabilityMutationVariables>(DevDeleteTemporaryAvailabilityDocument, options);
      }
export type DevDeleteTemporaryAvailabilityMutationHookResult = ReturnType<typeof useDevDeleteTemporaryAvailabilityMutation>;
export type DevDeleteTemporaryAvailabilityMutationResult = Apollo.MutationResult<DevDeleteTemporaryAvailabilityMutation>;
export type DevDeleteTemporaryAvailabilityMutationOptions = Apollo.BaseMutationOptions<DevDeleteTemporaryAvailabilityMutation, DevDeleteTemporaryAvailabilityMutationVariables>;
export const DevUpdateInterviewerDocument = gql`
    mutation DevUpdateInterviewer($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    id
  }
}
    `;
export type DevUpdateInterviewerMutationFn = Apollo.MutationFunction<DevUpdateInterviewerMutation, DevUpdateInterviewerMutationVariables>;

/**
 * __useDevUpdateInterviewerMutation__
 *
 * To run a mutation, you first call `useDevUpdateInterviewerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDevUpdateInterviewerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [devUpdateInterviewerMutation, { data, loading, error }] = useDevUpdateInterviewerMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDevUpdateInterviewerMutation(baseOptions?: Apollo.MutationHookOptions<DevUpdateInterviewerMutation, DevUpdateInterviewerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DevUpdateInterviewerMutation, DevUpdateInterviewerMutationVariables>(DevUpdateInterviewerDocument, options);
      }
export type DevUpdateInterviewerMutationHookResult = ReturnType<typeof useDevUpdateInterviewerMutation>;
export type DevUpdateInterviewerMutationResult = Apollo.MutationResult<DevUpdateInterviewerMutation>;
export type DevUpdateInterviewerMutationOptions = Apollo.BaseMutationOptions<DevUpdateInterviewerMutation, DevUpdateInterviewerMutationVariables>;
export const InterviewerSupportedLocalesDocument = gql`
    query InterviewerSupportedLocales {
  thisOrg {
    id
    supportedLocales
  }
}
    `;

/**
 * __useInterviewerSupportedLocalesQuery__
 *
 * To run a query within a React component, call `useInterviewerSupportedLocalesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerSupportedLocalesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerSupportedLocalesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterviewerSupportedLocalesQuery(baseOptions?: Apollo.QueryHookOptions<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>(InterviewerSupportedLocalesDocument, options);
      }
export function useInterviewerSupportedLocalesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>(InterviewerSupportedLocalesDocument, options);
        }
// @ts-ignore
export function useInterviewerSupportedLocalesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>;
export function useInterviewerSupportedLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerSupportedLocalesQuery | undefined, InterviewerSupportedLocalesQueryVariables>;
export function useInterviewerSupportedLocalesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>(InterviewerSupportedLocalesDocument, options);
        }
export type InterviewerSupportedLocalesQueryHookResult = ReturnType<typeof useInterviewerSupportedLocalesQuery>;
export type InterviewerSupportedLocalesLazyQueryHookResult = ReturnType<typeof useInterviewerSupportedLocalesLazyQuery>;
export type InterviewerSupportedLocalesSuspenseQueryHookResult = ReturnType<typeof useInterviewerSupportedLocalesSuspenseQuery>;
export type InterviewerSupportedLocalesQueryResult = Apollo.QueryResult<InterviewerSupportedLocalesQuery, InterviewerSupportedLocalesQueryVariables>;
export const GetOrgRequiredOnboardingStatusDocument = gql`
    query GetOrgRequiredOnboardingStatus {
  thisOrg {
    id
    atsStatus
    directoryStatus
  }
}
    `;

/**
 * __useGetOrgRequiredOnboardingStatusQuery__
 *
 * To run a query within a React component, call `useGetOrgRequiredOnboardingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOrgRequiredOnboardingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOrgRequiredOnboardingStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOrgRequiredOnboardingStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>(GetOrgRequiredOnboardingStatusDocument, options);
      }
export function useGetOrgRequiredOnboardingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>(GetOrgRequiredOnboardingStatusDocument, options);
        }
// @ts-ignore
export function useGetOrgRequiredOnboardingStatusSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>;
export function useGetOrgRequiredOnboardingStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>): Apollo.UseSuspenseQueryResult<GetOrgRequiredOnboardingStatusQuery | undefined, GetOrgRequiredOnboardingStatusQueryVariables>;
export function useGetOrgRequiredOnboardingStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>(GetOrgRequiredOnboardingStatusDocument, options);
        }
export type GetOrgRequiredOnboardingStatusQueryHookResult = ReturnType<typeof useGetOrgRequiredOnboardingStatusQuery>;
export type GetOrgRequiredOnboardingStatusLazyQueryHookResult = ReturnType<typeof useGetOrgRequiredOnboardingStatusLazyQuery>;
export type GetOrgRequiredOnboardingStatusSuspenseQueryHookResult = ReturnType<typeof useGetOrgRequiredOnboardingStatusSuspenseQuery>;
export type GetOrgRequiredOnboardingStatusQueryResult = Apollo.QueryResult<GetOrgRequiredOnboardingStatusQuery, GetOrgRequiredOnboardingStatusQueryVariables>;
export const UserTermsOfServiceDocument = gql`
    query UserTermsOfService {
  thisInterviewer {
    id
    tosAcceptedAt
  }
}
    `;

/**
 * __useUserTermsOfServiceQuery__
 *
 * To run a query within a React component, call `useUserTermsOfServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserTermsOfServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserTermsOfServiceQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserTermsOfServiceQuery(baseOptions?: Apollo.QueryHookOptions<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>(UserTermsOfServiceDocument, options);
      }
export function useUserTermsOfServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>(UserTermsOfServiceDocument, options);
        }
// @ts-ignore
export function useUserTermsOfServiceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>): Apollo.UseSuspenseQueryResult<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>;
export function useUserTermsOfServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>): Apollo.UseSuspenseQueryResult<UserTermsOfServiceQuery | undefined, UserTermsOfServiceQueryVariables>;
export function useUserTermsOfServiceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>(UserTermsOfServiceDocument, options);
        }
export type UserTermsOfServiceQueryHookResult = ReturnType<typeof useUserTermsOfServiceQuery>;
export type UserTermsOfServiceLazyQueryHookResult = ReturnType<typeof useUserTermsOfServiceLazyQuery>;
export type UserTermsOfServiceSuspenseQueryHookResult = ReturnType<typeof useUserTermsOfServiceSuspenseQuery>;
export type UserTermsOfServiceQueryResult = Apollo.QueryResult<UserTermsOfServiceQuery, UserTermsOfServiceQueryVariables>;
export const InterviewerLocaleDocument = gql`
    query InterviewerLocale {
  thisInterviewer {
    id
    locale
  }
}
    `;

/**
 * __useInterviewerLocaleQuery__
 *
 * To run a query within a React component, call `useInterviewerLocaleQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerLocaleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerLocaleQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterviewerLocaleQuery(baseOptions?: Apollo.QueryHookOptions<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>(InterviewerLocaleDocument, options);
      }
export function useInterviewerLocaleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>(InterviewerLocaleDocument, options);
        }
// @ts-ignore
export function useInterviewerLocaleSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>;
export function useInterviewerLocaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerLocaleQuery | undefined, InterviewerLocaleQueryVariables>;
export function useInterviewerLocaleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>(InterviewerLocaleDocument, options);
        }
export type InterviewerLocaleQueryHookResult = ReturnType<typeof useInterviewerLocaleQuery>;
export type InterviewerLocaleLazyQueryHookResult = ReturnType<typeof useInterviewerLocaleLazyQuery>;
export type InterviewerLocaleSuspenseQueryHookResult = ReturnType<typeof useInterviewerLocaleSuspenseQuery>;
export type InterviewerLocaleQueryResult = Apollo.QueryResult<InterviewerLocaleQuery, InterviewerLocaleQueryVariables>;
export const UpdateInterviewerLocaleDocument = gql`
    mutation UpdateInterviewerLocale($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    id
    locale
  }
}
    `;
export type UpdateInterviewerLocaleMutationFn = Apollo.MutationFunction<UpdateInterviewerLocaleMutation, UpdateInterviewerLocaleMutationVariables>;

/**
 * __useUpdateInterviewerLocaleMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewerLocaleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewerLocaleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewerLocaleMutation, { data, loading, error }] = useUpdateInterviewerLocaleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewerLocaleMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewerLocaleMutation, UpdateInterviewerLocaleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewerLocaleMutation, UpdateInterviewerLocaleMutationVariables>(UpdateInterviewerLocaleDocument, options);
      }
export type UpdateInterviewerLocaleMutationHookResult = ReturnType<typeof useUpdateInterviewerLocaleMutation>;
export type UpdateInterviewerLocaleMutationResult = Apollo.MutationResult<UpdateInterviewerLocaleMutation>;
export type UpdateInterviewerLocaleMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewerLocaleMutation, UpdateInterviewerLocaleMutationVariables>;
export const OrgNameDocument = gql`
    query OrgName {
  thisOrg {
    id
    name
  }
}
    `;

/**
 * __useOrgNameQuery__
 *
 * To run a query within a React component, call `useOrgNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrgNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrgNameQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrgNameQuery(baseOptions?: Apollo.QueryHookOptions<OrgNameQuery, OrgNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrgNameQuery, OrgNameQueryVariables>(OrgNameDocument, options);
      }
export function useOrgNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrgNameQuery, OrgNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrgNameQuery, OrgNameQueryVariables>(OrgNameDocument, options);
        }
// @ts-ignore
export function useOrgNameSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<OrgNameQuery, OrgNameQueryVariables>): Apollo.UseSuspenseQueryResult<OrgNameQuery, OrgNameQueryVariables>;
export function useOrgNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgNameQuery, OrgNameQueryVariables>): Apollo.UseSuspenseQueryResult<OrgNameQuery | undefined, OrgNameQueryVariables>;
export function useOrgNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OrgNameQuery, OrgNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OrgNameQuery, OrgNameQueryVariables>(OrgNameDocument, options);
        }
export type OrgNameQueryHookResult = ReturnType<typeof useOrgNameQuery>;
export type OrgNameLazyQueryHookResult = ReturnType<typeof useOrgNameLazyQuery>;
export type OrgNameSuspenseQueryHookResult = ReturnType<typeof useOrgNameSuspenseQuery>;
export type OrgNameQueryResult = Apollo.QueryResult<OrgNameQuery, OrgNameQueryVariables>;
export const GetAdditionalPreferencesDocument = gql`
    query GetAdditionalPreferences {
  thisInterviewer {
    id
    ...FeedbackWritingTimeSection_interviewer
  }
}
    ${FeedbackWritingTimeSection_InterviewerFragmentDoc}`;

/**
 * __useGetAdditionalPreferencesQuery__
 *
 * To run a query within a React component, call `useGetAdditionalPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdditionalPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdditionalPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdditionalPreferencesQuery(baseOptions?: Apollo.QueryHookOptions<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>(GetAdditionalPreferencesDocument, options);
      }
export function useGetAdditionalPreferencesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>(GetAdditionalPreferencesDocument, options);
        }
// @ts-ignore
export function useGetAdditionalPreferencesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>;
export function useGetAdditionalPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdditionalPreferencesQuery | undefined, GetAdditionalPreferencesQueryVariables>;
export function useGetAdditionalPreferencesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>(GetAdditionalPreferencesDocument, options);
        }
export type GetAdditionalPreferencesQueryHookResult = ReturnType<typeof useGetAdditionalPreferencesQuery>;
export type GetAdditionalPreferencesLazyQueryHookResult = ReturnType<typeof useGetAdditionalPreferencesLazyQuery>;
export type GetAdditionalPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetAdditionalPreferencesSuspenseQuery>;
export type GetAdditionalPreferencesQueryResult = Apollo.QueryResult<GetAdditionalPreferencesQuery, GetAdditionalPreferencesQueryVariables>;
export const UpdateInterviewerAdditionalPreferencesDocument = gql`
    mutation UpdateInterviewerAdditionalPreferences($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    id
    ...FeedbackWritingTimeSection_interviewer
  }
}
    ${FeedbackWritingTimeSection_InterviewerFragmentDoc}`;
export type UpdateInterviewerAdditionalPreferencesMutationFn = Apollo.MutationFunction<UpdateInterviewerAdditionalPreferencesMutation, UpdateInterviewerAdditionalPreferencesMutationVariables>;

/**
 * __useUpdateInterviewerAdditionalPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewerAdditionalPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewerAdditionalPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewerAdditionalPreferencesMutation, { data, loading, error }] = useUpdateInterviewerAdditionalPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewerAdditionalPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewerAdditionalPreferencesMutation, UpdateInterviewerAdditionalPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewerAdditionalPreferencesMutation, UpdateInterviewerAdditionalPreferencesMutationVariables>(UpdateInterviewerAdditionalPreferencesDocument, options);
      }
export type UpdateInterviewerAdditionalPreferencesMutationHookResult = ReturnType<typeof useUpdateInterviewerAdditionalPreferencesMutation>;
export type UpdateInterviewerAdditionalPreferencesMutationResult = Apollo.MutationResult<UpdateInterviewerAdditionalPreferencesMutation>;
export type UpdateInterviewerAdditionalPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewerAdditionalPreferencesMutation, UpdateInterviewerAdditionalPreferencesMutationVariables>;
export const GetAvailabilityDocument = gql`
    query GetAvailability {
  thisInterviewer {
    ...EditLimitsButton_interviewer
    ...EditAvailabilityDialog_interviewer
    ...BufferTimesSection_interviewer
    id
    timezoneSettings {
      interviewerTimezone
      calendarTimezone
      useCalendarTimezone
    }
    ...InterviewerWorkHours
    interviewLimits {
      dailyInterviewLimit {
        currentLimit {
          type
          value
        }
        level
      }
      weeklyInterviewLimit {
        currentLimit {
          type
          value
        }
        level
      }
    }
  }
}
    ${EditLimitsButton_InterviewerFragmentDoc}
${EditAvailabilityDialog_InterviewerFragmentDoc}
${BufferTimesSection_InterviewerFragmentDoc}
${InterviewerWorkHoursFragmentDoc}`;

/**
 * __useGetAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailabilityQuery, GetAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailabilityQuery, GetAvailabilityQueryVariables>(GetAvailabilityDocument, options);
      }
export function useGetAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailabilityQuery, GetAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailabilityQuery, GetAvailabilityQueryVariables>(GetAvailabilityDocument, options);
        }
// @ts-ignore
export function useGetAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAvailabilityQuery, GetAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailabilityQuery, GetAvailabilityQueryVariables>;
export function useGetAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailabilityQuery, GetAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetAvailabilityQuery | undefined, GetAvailabilityQueryVariables>;
export function useGetAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailabilityQuery, GetAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailabilityQuery, GetAvailabilityQueryVariables>(GetAvailabilityDocument, options);
        }
export type GetAvailabilityQueryHookResult = ReturnType<typeof useGetAvailabilityQuery>;
export type GetAvailabilityLazyQueryHookResult = ReturnType<typeof useGetAvailabilityLazyQuery>;
export type GetAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetAvailabilitySuspenseQuery>;
export type GetAvailabilityQueryResult = Apollo.QueryResult<GetAvailabilityQuery, GetAvailabilityQueryVariables>;
export const UpdateInterviewerAvailabilityDocument = gql`
    mutation UpdateInterviewerAvailability($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    id
    ...BufferTimesSection_interviewer
    timezoneSettings {
      interviewerTimezone
      calendarTimezone
      useCalendarTimezone
    }
    interviewLimits {
      dailyInterviewLimit {
        currentLimit {
          type
          value
        }
        level
      }
      weeklyInterviewLimit {
        currentLimit {
          type
          value
        }
        level
      }
    }
    ...InterviewerWorkHours
  }
}
    ${BufferTimesSection_InterviewerFragmentDoc}
${InterviewerWorkHoursFragmentDoc}`;
export type UpdateInterviewerAvailabilityMutationFn = Apollo.MutationFunction<UpdateInterviewerAvailabilityMutation, UpdateInterviewerAvailabilityMutationVariables>;

/**
 * __useUpdateInterviewerAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewerAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewerAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewerAvailabilityMutation, { data, loading, error }] = useUpdateInterviewerAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewerAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewerAvailabilityMutation, UpdateInterviewerAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewerAvailabilityMutation, UpdateInterviewerAvailabilityMutationVariables>(UpdateInterviewerAvailabilityDocument, options);
      }
export type UpdateInterviewerAvailabilityMutationHookResult = ReturnType<typeof useUpdateInterviewerAvailabilityMutation>;
export type UpdateInterviewerAvailabilityMutationResult = Apollo.MutationResult<UpdateInterviewerAvailabilityMutation>;
export type UpdateInterviewerAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewerAvailabilityMutation, UpdateInterviewerAvailabilityMutationVariables>;
export const GetExternalInfoDocument = gql`
    query GetExternalInfo {
  thisInterviewer {
    ...ExternalInfo
  }
}
    ${ExternalInfoFragmentDoc}`;

/**
 * __useGetExternalInfoQuery__
 *
 * To run a query within a React component, call `useGetExternalInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExternalInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExternalInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExternalInfoQuery(baseOptions?: Apollo.QueryHookOptions<GetExternalInfoQuery, GetExternalInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExternalInfoQuery, GetExternalInfoQueryVariables>(GetExternalInfoDocument, options);
      }
export function useGetExternalInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExternalInfoQuery, GetExternalInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExternalInfoQuery, GetExternalInfoQueryVariables>(GetExternalInfoDocument, options);
        }
// @ts-ignore
export function useGetExternalInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExternalInfoQuery, GetExternalInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalInfoQuery, GetExternalInfoQueryVariables>;
export function useGetExternalInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalInfoQuery, GetExternalInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetExternalInfoQuery | undefined, GetExternalInfoQueryVariables>;
export function useGetExternalInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExternalInfoQuery, GetExternalInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExternalInfoQuery, GetExternalInfoQueryVariables>(GetExternalInfoDocument, options);
        }
export type GetExternalInfoQueryHookResult = ReturnType<typeof useGetExternalInfoQuery>;
export type GetExternalInfoLazyQueryHookResult = ReturnType<typeof useGetExternalInfoLazyQuery>;
export type GetExternalInfoSuspenseQueryHookResult = ReturnType<typeof useGetExternalInfoSuspenseQuery>;
export type GetExternalInfoQueryResult = Apollo.QueryResult<GetExternalInfoQuery, GetExternalInfoQueryVariables>;
export const UpdateInterviewerExternalInfoDocument = gql`
    mutation UpdateInterviewerExternalInfo($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    ...ExternalInfo
  }
}
    ${ExternalInfoFragmentDoc}`;
export type UpdateInterviewerExternalInfoMutationFn = Apollo.MutationFunction<UpdateInterviewerExternalInfoMutation, UpdateInterviewerExternalInfoMutationVariables>;

/**
 * __useUpdateInterviewerExternalInfoMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewerExternalInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewerExternalInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewerExternalInfoMutation, { data, loading, error }] = useUpdateInterviewerExternalInfoMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewerExternalInfoMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewerExternalInfoMutation, UpdateInterviewerExternalInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewerExternalInfoMutation, UpdateInterviewerExternalInfoMutationVariables>(UpdateInterviewerExternalInfoDocument, options);
      }
export type UpdateInterviewerExternalInfoMutationHookResult = ReturnType<typeof useUpdateInterviewerExternalInfoMutation>;
export type UpdateInterviewerExternalInfoMutationResult = Apollo.MutationResult<UpdateInterviewerExternalInfoMutation>;
export type UpdateInterviewerExternalInfoMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewerExternalInfoMutation, UpdateInterviewerExternalInfoMutationVariables>;
export const UpdateInterviewerAvailabileKeywordsDocument = gql`
    mutation UpdateInterviewerAvailabileKeywords($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    id
    keywords {
      available {
        current
        org
        level
      }
    }
  }
}
    `;
export type UpdateInterviewerAvailabileKeywordsMutationFn = Apollo.MutationFunction<UpdateInterviewerAvailabileKeywordsMutation, UpdateInterviewerAvailabileKeywordsMutationVariables>;

/**
 * __useUpdateInterviewerAvailabileKeywordsMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewerAvailabileKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewerAvailabileKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewerAvailabileKeywordsMutation, { data, loading, error }] = useUpdateInterviewerAvailabileKeywordsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewerAvailabileKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewerAvailabileKeywordsMutation, UpdateInterviewerAvailabileKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewerAvailabileKeywordsMutation, UpdateInterviewerAvailabileKeywordsMutationVariables>(UpdateInterviewerAvailabileKeywordsDocument, options);
      }
export type UpdateInterviewerAvailabileKeywordsMutationHookResult = ReturnType<typeof useUpdateInterviewerAvailabileKeywordsMutation>;
export type UpdateInterviewerAvailabileKeywordsMutationResult = Apollo.MutationResult<UpdateInterviewerAvailabileKeywordsMutation>;
export type UpdateInterviewerAvailabileKeywordsMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewerAvailabileKeywordsMutation, UpdateInterviewerAvailabileKeywordsMutationVariables>;
export const UpdateInterviewerAvoidKeywordsDocument = gql`
    mutation UpdateInterviewerAvoidKeywords($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    id
    keywords {
      avoid {
        current
        org
        level
      }
    }
  }
}
    `;
export type UpdateInterviewerAvoidKeywordsMutationFn = Apollo.MutationFunction<UpdateInterviewerAvoidKeywordsMutation, UpdateInterviewerAvoidKeywordsMutationVariables>;

/**
 * __useUpdateInterviewerAvoidKeywordsMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewerAvoidKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewerAvoidKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewerAvoidKeywordsMutation, { data, loading, error }] = useUpdateInterviewerAvoidKeywordsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewerAvoidKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewerAvoidKeywordsMutation, UpdateInterviewerAvoidKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewerAvoidKeywordsMutation, UpdateInterviewerAvoidKeywordsMutationVariables>(UpdateInterviewerAvoidKeywordsDocument, options);
      }
export type UpdateInterviewerAvoidKeywordsMutationHookResult = ReturnType<typeof useUpdateInterviewerAvoidKeywordsMutation>;
export type UpdateInterviewerAvoidKeywordsMutationResult = Apollo.MutationResult<UpdateInterviewerAvoidKeywordsMutation>;
export type UpdateInterviewerAvoidKeywordsMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewerAvoidKeywordsMutation, UpdateInterviewerAvoidKeywordsMutationVariables>;
export const UpdateInterviewerOutOfOfficeKeywordsDocument = gql`
    mutation UpdateInterviewerOutOfOfficeKeywords($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    id
    keywords {
      outOfOffice {
        current
        org
        level
      }
    }
  }
}
    `;
export type UpdateInterviewerOutOfOfficeKeywordsMutationFn = Apollo.MutationFunction<UpdateInterviewerOutOfOfficeKeywordsMutation, UpdateInterviewerOutOfOfficeKeywordsMutationVariables>;

/**
 * __useUpdateInterviewerOutOfOfficeKeywordsMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewerOutOfOfficeKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewerOutOfOfficeKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewerOutOfOfficeKeywordsMutation, { data, loading, error }] = useUpdateInterviewerOutOfOfficeKeywordsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewerOutOfOfficeKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewerOutOfOfficeKeywordsMutation, UpdateInterviewerOutOfOfficeKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewerOutOfOfficeKeywordsMutation, UpdateInterviewerOutOfOfficeKeywordsMutationVariables>(UpdateInterviewerOutOfOfficeKeywordsDocument, options);
      }
export type UpdateInterviewerOutOfOfficeKeywordsMutationHookResult = ReturnType<typeof useUpdateInterviewerOutOfOfficeKeywordsMutation>;
export type UpdateInterviewerOutOfOfficeKeywordsMutationResult = Apollo.MutationResult<UpdateInterviewerOutOfOfficeKeywordsMutation>;
export type UpdateInterviewerOutOfOfficeKeywordsMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewerOutOfOfficeKeywordsMutation, UpdateInterviewerOutOfOfficeKeywordsMutationVariables>;
export const UpdateInterviewerRecruitingBlocksKeywordsDocument = gql`
    mutation UpdateInterviewerRecruitingBlocksKeywords($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    id
    keywords {
      recruitingBlocks {
        current
        org
        level
      }
    }
  }
}
    `;
export type UpdateInterviewerRecruitingBlocksKeywordsMutationFn = Apollo.MutationFunction<UpdateInterviewerRecruitingBlocksKeywordsMutation, UpdateInterviewerRecruitingBlocksKeywordsMutationVariables>;

/**
 * __useUpdateInterviewerRecruitingBlocksKeywordsMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewerRecruitingBlocksKeywordsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewerRecruitingBlocksKeywordsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewerRecruitingBlocksKeywordsMutation, { data, loading, error }] = useUpdateInterviewerRecruitingBlocksKeywordsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewerRecruitingBlocksKeywordsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewerRecruitingBlocksKeywordsMutation, UpdateInterviewerRecruitingBlocksKeywordsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewerRecruitingBlocksKeywordsMutation, UpdateInterviewerRecruitingBlocksKeywordsMutationVariables>(UpdateInterviewerRecruitingBlocksKeywordsDocument, options);
      }
export type UpdateInterviewerRecruitingBlocksKeywordsMutationHookResult = ReturnType<typeof useUpdateInterviewerRecruitingBlocksKeywordsMutation>;
export type UpdateInterviewerRecruitingBlocksKeywordsMutationResult = Apollo.MutationResult<UpdateInterviewerRecruitingBlocksKeywordsMutation>;
export type UpdateInterviewerRecruitingBlocksKeywordsMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewerRecruitingBlocksKeywordsMutation, UpdateInterviewerRecruitingBlocksKeywordsMutationVariables>;
export const InterviewerKeywordsDocument = gql`
    query InterviewerKeywords {
  thisInterviewer {
    ...AvailableKeywordsField_interviewer
    ...AvoidKeywordsField_interviewer
    ...OutOfOfficeKeywordsField_interviewer
    ...RecruitingBlocksKeywordsField_interviewer
  }
}
    ${AvailableKeywordsField_InterviewerFragmentDoc}
${AvoidKeywordsField_InterviewerFragmentDoc}
${OutOfOfficeKeywordsField_InterviewerFragmentDoc}
${RecruitingBlocksKeywordsField_InterviewerFragmentDoc}`;

/**
 * __useInterviewerKeywordsQuery__
 *
 * To run a query within a React component, call `useInterviewerKeywordsQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewerKeywordsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewerKeywordsQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterviewerKeywordsQuery(baseOptions?: Apollo.QueryHookOptions<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>(InterviewerKeywordsDocument, options);
      }
export function useInterviewerKeywordsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>(InterviewerKeywordsDocument, options);
        }
// @ts-ignore
export function useInterviewerKeywordsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>;
export function useInterviewerKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>): Apollo.UseSuspenseQueryResult<InterviewerKeywordsQuery | undefined, InterviewerKeywordsQueryVariables>;
export function useInterviewerKeywordsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>(InterviewerKeywordsDocument, options);
        }
export type InterviewerKeywordsQueryHookResult = ReturnType<typeof useInterviewerKeywordsQuery>;
export type InterviewerKeywordsLazyQueryHookResult = ReturnType<typeof useInterviewerKeywordsLazyQuery>;
export type InterviewerKeywordsSuspenseQueryHookResult = ReturnType<typeof useInterviewerKeywordsSuspenseQuery>;
export type InterviewerKeywordsQueryResult = Apollo.QueryResult<InterviewerKeywordsQuery, InterviewerKeywordsQueryVariables>;
export const GetPlannedAvailabilityDocument = gql`
    query GetPlannedAvailability {
  thisInterviewer {
    id
    plannedAvailability {
      ...PlannedAvailability
    }
    pauseDates {
      start
      end
    }
    workHours {
      orgHours {
        ...WorkHours
      }
    }
  }
}
    ${PlannedAvailabilityFragmentDoc}
${WorkHoursFragmentDoc}`;

/**
 * __useGetPlannedAvailabilityQuery__
 *
 * To run a query within a React component, call `useGetPlannedAvailabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPlannedAvailabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPlannedAvailabilityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPlannedAvailabilityQuery(baseOptions?: Apollo.QueryHookOptions<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>(GetPlannedAvailabilityDocument, options);
      }
export function useGetPlannedAvailabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>(GetPlannedAvailabilityDocument, options);
        }
// @ts-ignore
export function useGetPlannedAvailabilitySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>;
export function useGetPlannedAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>): Apollo.UseSuspenseQueryResult<GetPlannedAvailabilityQuery | undefined, GetPlannedAvailabilityQueryVariables>;
export function useGetPlannedAvailabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>(GetPlannedAvailabilityDocument, options);
        }
export type GetPlannedAvailabilityQueryHookResult = ReturnType<typeof useGetPlannedAvailabilityQuery>;
export type GetPlannedAvailabilityLazyQueryHookResult = ReturnType<typeof useGetPlannedAvailabilityLazyQuery>;
export type GetPlannedAvailabilitySuspenseQueryHookResult = ReturnType<typeof useGetPlannedAvailabilitySuspenseQuery>;
export type GetPlannedAvailabilityQueryResult = Apollo.QueryResult<GetPlannedAvailabilityQuery, GetPlannedAvailabilityQueryVariables>;
export const UpdateInterviewerPauseDatesDocument = gql`
    mutation UpdateInterviewerPauseDates($input: UpdateInterviewerInput!) {
  updateInterviewer(input: $input) {
    id
    pauseDates {
      start
      end
    }
  }
}
    `;
export type UpdateInterviewerPauseDatesMutationFn = Apollo.MutationFunction<UpdateInterviewerPauseDatesMutation, UpdateInterviewerPauseDatesMutationVariables>;

/**
 * __useUpdateInterviewerPauseDatesMutation__
 *
 * To run a mutation, you first call `useUpdateInterviewerPauseDatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInterviewerPauseDatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInterviewerPauseDatesMutation, { data, loading, error }] = useUpdateInterviewerPauseDatesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateInterviewerPauseDatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateInterviewerPauseDatesMutation, UpdateInterviewerPauseDatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateInterviewerPauseDatesMutation, UpdateInterviewerPauseDatesMutationVariables>(UpdateInterviewerPauseDatesDocument, options);
      }
export type UpdateInterviewerPauseDatesMutationHookResult = ReturnType<typeof useUpdateInterviewerPauseDatesMutation>;
export type UpdateInterviewerPauseDatesMutationResult = Apollo.MutationResult<UpdateInterviewerPauseDatesMutation>;
export type UpdateInterviewerPauseDatesMutationOptions = Apollo.BaseMutationOptions<UpdateInterviewerPauseDatesMutation, UpdateInterviewerPauseDatesMutationVariables>;
export const CreatePlannedAvailabilityDocument = gql`
    mutation CreatePlannedAvailability($input: PlannedAvailabilityCreateInput!) {
  plannedAvailabilityCreate(input: $input) {
    id
    plannedAvailability {
      ...PlannedAvailability
    }
  }
}
    ${PlannedAvailabilityFragmentDoc}`;
export type CreatePlannedAvailabilityMutationFn = Apollo.MutationFunction<CreatePlannedAvailabilityMutation, CreatePlannedAvailabilityMutationVariables>;

/**
 * __useCreatePlannedAvailabilityMutation__
 *
 * To run a mutation, you first call `useCreatePlannedAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePlannedAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPlannedAvailabilityMutation, { data, loading, error }] = useCreatePlannedAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreatePlannedAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<CreatePlannedAvailabilityMutation, CreatePlannedAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePlannedAvailabilityMutation, CreatePlannedAvailabilityMutationVariables>(CreatePlannedAvailabilityDocument, options);
      }
export type CreatePlannedAvailabilityMutationHookResult = ReturnType<typeof useCreatePlannedAvailabilityMutation>;
export type CreatePlannedAvailabilityMutationResult = Apollo.MutationResult<CreatePlannedAvailabilityMutation>;
export type CreatePlannedAvailabilityMutationOptions = Apollo.BaseMutationOptions<CreatePlannedAvailabilityMutation, CreatePlannedAvailabilityMutationVariables>;
export const UpdatePlannedAvailabilityDocument = gql`
    mutation UpdatePlannedAvailability($input: PlannedAvailabilityUpdateInput!) {
  plannedAvailabilityUpdate(input: $input) {
    id
    plannedAvailability {
      ...PlannedAvailability
    }
  }
}
    ${PlannedAvailabilityFragmentDoc}`;
export type UpdatePlannedAvailabilityMutationFn = Apollo.MutationFunction<UpdatePlannedAvailabilityMutation, UpdatePlannedAvailabilityMutationVariables>;

/**
 * __useUpdatePlannedAvailabilityMutation__
 *
 * To run a mutation, you first call `useUpdatePlannedAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePlannedAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePlannedAvailabilityMutation, { data, loading, error }] = useUpdatePlannedAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdatePlannedAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePlannedAvailabilityMutation, UpdatePlannedAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePlannedAvailabilityMutation, UpdatePlannedAvailabilityMutationVariables>(UpdatePlannedAvailabilityDocument, options);
      }
export type UpdatePlannedAvailabilityMutationHookResult = ReturnType<typeof useUpdatePlannedAvailabilityMutation>;
export type UpdatePlannedAvailabilityMutationResult = Apollo.MutationResult<UpdatePlannedAvailabilityMutation>;
export type UpdatePlannedAvailabilityMutationOptions = Apollo.BaseMutationOptions<UpdatePlannedAvailabilityMutation, UpdatePlannedAvailabilityMutationVariables>;
export const DeletePlannedAvailabilityDocument = gql`
    mutation DeletePlannedAvailability($input: PlannedAvailabilityDeleteInput!) {
  plannedAvailabilityDelete(input: $input) {
    result
  }
}
    `;
export type DeletePlannedAvailabilityMutationFn = Apollo.MutationFunction<DeletePlannedAvailabilityMutation, DeletePlannedAvailabilityMutationVariables>;

/**
 * __useDeletePlannedAvailabilityMutation__
 *
 * To run a mutation, you first call `useDeletePlannedAvailabilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePlannedAvailabilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePlannedAvailabilityMutation, { data, loading, error }] = useDeletePlannedAvailabilityMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeletePlannedAvailabilityMutation(baseOptions?: Apollo.MutationHookOptions<DeletePlannedAvailabilityMutation, DeletePlannedAvailabilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePlannedAvailabilityMutation, DeletePlannedAvailabilityMutationVariables>(DeletePlannedAvailabilityDocument, options);
      }
export type DeletePlannedAvailabilityMutationHookResult = ReturnType<typeof useDeletePlannedAvailabilityMutation>;
export type DeletePlannedAvailabilityMutationResult = Apollo.MutationResult<DeletePlannedAvailabilityMutation>;
export type DeletePlannedAvailabilityMutationOptions = Apollo.BaseMutationOptions<DeletePlannedAvailabilityMutation, DeletePlannedAvailabilityMutationVariables>;
export const SaveTermsOfServiceDocument = gql`
    mutation SaveTermsOfService {
  acceptTermsOfService {
    result
  }
}
    `;
export type SaveTermsOfServiceMutationFn = Apollo.MutationFunction<SaveTermsOfServiceMutation, SaveTermsOfServiceMutationVariables>;

/**
 * __useSaveTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useSaveTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTermsOfServiceMutation, { data, loading, error }] = useSaveTermsOfServiceMutation({
 *   variables: {
 *   },
 * });
 */
export function useSaveTermsOfServiceMutation(baseOptions?: Apollo.MutationHookOptions<SaveTermsOfServiceMutation, SaveTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTermsOfServiceMutation, SaveTermsOfServiceMutationVariables>(SaveTermsOfServiceDocument, options);
      }
export type SaveTermsOfServiceMutationHookResult = ReturnType<typeof useSaveTermsOfServiceMutation>;
export type SaveTermsOfServiceMutationResult = Apollo.MutationResult<SaveTermsOfServiceMutation>;
export type SaveTermsOfServiceMutationOptions = Apollo.BaseMutationOptions<SaveTermsOfServiceMutation, SaveTermsOfServiceMutationVariables>;
export const GetInterviewerConfigDocument = gql`
    query GetInterviewerConfig {
  thisOrg {
    id
    fieldPermissions {
      firstName
      lastName
      title
      emailAddress
      linkedinUrl
      timezone
      interviewLoadCapacity
      interviewAvailability
      temporaryAvailability
      pauseFromInterviews
      interviewerKeywords
      profilePicture
      bio
      pronouns
      bufferTime
      feedbackWritingTime
    }
  }
}
    `;

/**
 * __useGetInterviewerConfigQuery__
 *
 * To run a query within a React component, call `useGetInterviewerConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterviewerConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterviewerConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInterviewerConfigQuery(baseOptions?: Apollo.QueryHookOptions<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>(GetInterviewerConfigDocument, options);
      }
export function useGetInterviewerConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>(GetInterviewerConfigDocument, options);
        }
// @ts-ignore
export function useGetInterviewerConfigSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>;
export function useGetInterviewerConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>): Apollo.UseSuspenseQueryResult<GetInterviewerConfigQuery | undefined, GetInterviewerConfigQueryVariables>;
export function useGetInterviewerConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>(GetInterviewerConfigDocument, options);
        }
export type GetInterviewerConfigQueryHookResult = ReturnType<typeof useGetInterviewerConfigQuery>;
export type GetInterviewerConfigLazyQueryHookResult = ReturnType<typeof useGetInterviewerConfigLazyQuery>;
export type GetInterviewerConfigSuspenseQueryHookResult = ReturnType<typeof useGetInterviewerConfigSuspenseQuery>;
export type GetInterviewerConfigQueryResult = Apollo.QueryResult<GetInterviewerConfigQuery, GetInterviewerConfigQueryVariables>;